<template>
  <div class="top laoding">
    <transition name="fade">
      <div v-if="state.loadText">なりたい自分へ…</div>
    </transition>
    <transition name="fade">
      <div v-if="state.loadText2">CYCLONE GYM</div>
    </transition>
    <!-- <div class="popup_loader_animation">Loading...</div> -->
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, computed, onMounted } from 'vue'
import IScroll from 'iscroll'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import { useApplicationStore } from '@/store/modules/applicationModule'

dayjs.locale('ja')

interface State {
  iScrollObj: null | IScroll
  loadText: boolean
  loadText2: boolean
}

export default defineComponent({
  name: 'App',
  components: {},
  setup() {
    const ApplicationStore = useApplicationStore()

    const root = ref(null)
    const state = reactive<State>({
      iScrollObj: null,
      loadText: true,
      loadText2: false,
    })

    const sleep = (waitTime) => new Promise((resolve) => setTimeout(resolve, waitTime))
    sleep(2000).then(() => {
      // 5秒停止後の処理
      state.loadText = false

      sleep(500).then(() => {
        // 5秒停止後の処理
        state.loadText2 = true

        sleep(2000).then(() => {
          // 5秒停止後の処理
          state.loadText2 = false
          //  ApplicationStore.isLoadComplete = true

          sleep(500).then(() => {
            // 5秒停止後の処理
            document.body.className = ''
            ApplicationStore.isLoadComplete = true
          })
        })
      })
    })

    onMounted(() => {
      document.body.className = 'loading'
    })

    const isLoadComplete = computed(() => ApplicationStore.isLoadComplete)

    return { state, root, isLoadComplete }
  },
})
</script>

<style lang="scss" scoped>
.top {
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 100001;
  font-family: 'Noto Serif JP', serif;
  font-size: 3rem;
}

.popup_loader_animation {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 11em;
  height: 11em;
  border-radius: 50%;
  background: linear-gradient(to right, white 10%, rgba(255, 255, 255, 0) 42%);
  top: 0;
  left: 0;
  animation: load 1.4s infinite linear;
}

.popup_loader_animation:before {
  width: 50%;
  height: 50%;
  background: white;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
}

.popup_loader_animation:after {
  background: black;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}

@keyframes load {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}

.vshow-enter-active,
.vshow-leave-active {
  transition: opacity 1100s;
}

.vshow-enter,
vshow-leave-to {
  opacity: 0;
}

.vif-enter-active,
.vif-leave-active {
  transition: opacity 500s;
}

.vif-enter,
vif-leave-to {
  opacity: 0;
}
</style>
